export default {
  common: {
    changePassword: "修改密码",
    logout: "退出登录"
  }
};
